import { cr, interact } from "fire-wind-water";
import { Elem } from "./elem";
import { monthPicker } from "./virtual/month";
import { relustList } from "./core/list";
import { initTrTd } from "./virtual/trthtd";
import { classNames } from "./core/setting";

class Month extends Elem {
  list: any;
  constructor(o) {
    super(o);
    this.resetModel = ["year", "month"];
  }

  setList() {
    this.list = relustList("month", this.value, this.model);
  }

  setModel(o) {
    const date = cr.isDate(o) ? o : new Date();
    this.setValue(date);
    this.resetRender();
  }

  resetRender(d?) {
    if (interact.isMobile === 1) {
      this.resetWapRender(d);
    } else {
      this.setList();
      this.setVirtual();
      this.render();
    }
  }

  setVirtual() {
    const trs = initTrTd("month", this.list, 3, (o) => {
      this.selectItem(o);
    });
    this.virtual = monthPicker(this, trs);
  }

  selectItem(o) {
    this.value.month = o.month;
    this.model = this.toDate();
    this.setClass();
    this.change({ model: this.model, value: this.value });
  }

  selectFirst(ev) {
    if (ev) {
      ev.stopPropagation();
    }
    this.value.year--;
    this.setVirtual();
    this.render();
    this.setClass();
  }

  selectLast(ev) {
    if (ev) {
      ev.stopPropagation();
    }
    this.value.year++;
    this.setVirtual();
    this.render();
    this.setClass();
  }

  setClass() {
    cr.each(this.items, (o, i) => {
      const d = this.list[i];
      o.className =
        d.year === this.value.year && d.month === this.value.month
          ? classNames.active
          : classNames.default;
    });
  }

  changeModel() {
    this.touchs.changeModel(this.value);
    this.model = this.toDate();
    this.change({ model: this.model, value: this.value });
    this.destroy();
  }
}

export { Month };
